var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListProducts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6933 10.6233V17.9283H17.7267V21.9867H10.5867V10.6233H21.6933ZM21.6933 9H10.5867C9.714 9 9 9.7305 9 10.6233V21.9867C9 22.8795 9.714 23.61 10.5867 23.61H18.52L23.28 18.74V10.6233C23.28 9.7305 22.566 9 21.6933 9ZM16.14 17.9283H12.1733V16.305H16.14V17.9283ZM20.1067 14.6817H12.1733V13.0583H20.1067V14.6817Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListProducts);
export default __webpack_public_path__ + "static/media/list-products.88afb8a0a11a3c7c00ef28eea62d0f71.svg";
export { ForwardRef as ReactComponent };